import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EchartsBlock } from '../../../model';
import { EchartsSvgComponent } from '../../../echarts/echarts-svg.component';

@Component({
  selector: 'dojo-echarts-block-renderer',
  standalone: true,
  template: ` <dojo-echarts-svg [options]="block().options" [style.height.px]="block().height ?? 400" /> `,
  styles: `
    :host {
      @apply block my-4;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EchartsSvgComponent],
})
export class EchartsBlockRendererComponent {
  readonly block = input.required<EchartsBlock>();
}
